/** First-steps guide API (apps/api/src/routes/onboarding.ts). Ten server-tracked steps, see packages/shared onboarding.ts. */
import { apiFetch } from './client.ts';
import type { OnboardingStateDto, OnboardingGoal } from '@galaxis/shared';

export type OnboardingState = OnboardingStateDto;

export type OnboardingEvent = 'home_viewed' | 'dismiss' | 'reopen' | 'production_seen' | 'energy_seen';

export const fetchOnboarding = () => apiFetch<OnboardingState>('/onboarding');
export const postOnboarding = (event: OnboardingEvent) =>
  apiFetch<OnboardingState>('/onboarding', { method: 'POST', body: JSON.stringify({ event }) });
export const postOnboardingGoal = (goal: OnboardingGoal) =>
  apiFetch<OnboardingState>('/onboarding', { method: 'POST', body: JSON.stringify({ event: 'goal', goal }) });
